import React, {useEffect, useState} from 'react';
import {apiMotivoAusenciasService} from "../../services/apiMotivoAusenciasService";
import {useAuth} from "../../context/AuthProvider";
import {Table} from "reactstrap";
import {apiAusenciasService} from "../../services/apiAusenciasService";

const ComputoAusenciasAnual = ({ empleadoId, year}) => {
    const {empresa} = useAuth();
    const [motivos, setMotivos] = useState([]);
    //const [recuentoAusencias, setRecuentoAusencias] = useState([])

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiAusenciasService.getComputoEmpleado(empleadoId, year);
            response.json().then((data) => {
                setMotivos(data);  // Correct usage of setMotivos
            });
        }

        fetchData()
    }, [empleadoId, empresa.id, year]);


    return (
        <div>
            <Table className="align-center table-flush table">
                <thead className="thead-light">
                    <tr>
                        <th>Motivo</th>
                        <th>Recuento</th>
                    </tr>
                </thead>
                <tbody>
                {motivos.map((motivo, index) => (
                    <tr key={index}>
                        <td>{motivo.motivo}</td>
                        <td>{motivo.recuento}</td>
                    </tr>
                ))}
                </tbody>
            </Table>
        </div>
    );
};

export default ComputoAusenciasAnual;